<template>
  <div class="wabident-object-field">
    <div class="row form-group wabident-object-field__item" v-for="(value, key) in object" :key="key">

      <!-- FIELDSET DECORATOR FOR CUSTOM VALUES -->
      <template v-if="decoration == 'fieldset'">
        <div class="col-md-2">
          Clave: <code>{{ key }}</code>
        </div>
        <div class="col-md-2">
          Nombre: {{ value.name }}
        </div>
        <div class="col-md-2">
          Desc: {{ value.desc }}
        </div>
        <div class="col-md-2">
          Tipo: {{ value.type }}
        </div>
        <div class="col-md-1">
          Ancho: {{ value.width }}
        </div>
        <div class="col-md-1">
          Orden: {{ value.order }}
        </div>
        <div class="col-md-1">
          Import: {{ value.important }}
        </div>
      </template>

      <!-- DEFAULT DECORATOR -->
      <template v-else>
        <div class="col-md-4">
          Clave: <code>{{ key }}</code>
        </div>
        <div class="col-md-6">
          Valor: <em>"{{ value }}"</em>
        </div>
      </template>

      <div class="col-md-2">
        <button @click="onDelete(key)" class="btn-wabident-round small red"><i class="fas fa-trash"></i></button>
      </div>

    </div>

    <div class="row form-group">

      <div class="col-md-2">
        <input v-model="tmp_key" type="text" class="form-control wabident-xsmall" :id="slug + '_key'">
        <label :for="slug" :id="slug + '_key'" class="wabident-info">Clave</label>
      </div>

      <template v-if="decoration == 'fieldset'">
        <div class="col-md-2">
          <input v-model="tmp_name" type="text" class="form-control wabident-xsmall" :id="slug + '_name'">
          <label :for="slug" :id="slug + '_name'" class="wabident-info">Nombre</label>
        </div>

        <div class="col-md-2">
          <textarea :id="slug + '_desc'" class="form-control" v-model="tmp_desc"></textarea>
          <label :for="slug" :id="slug + '_desc'" class="wabident-info">Desc.</label>
        </div>

        <div class="col-md-2">
          <select v-model="tmp_type" type="text" class="custom-select wabident-xsmall" :id="slug + '_type'">
            <option :value="null">Elige ...</option>
            <option value="text">Texto</option>
            <option value="textarea">Área de texto</option>
            <option value="email">Email</option>
            <option value="tel">Teléfono</option>
            <option value="date">Fecha</option>
            <option value="time">Hora</option>
            <option value="datetime">Fecha/Hora</option>
            <option value="checkboxes">Checkboxes</option>
            <option value="radiolist">Radiolist</option>
            <option value="select">Selector</option>
          </select>

          <label :for="slug" :id="slug + '_type'" class="wabident-info">Tipo.</label>
        </div>

        <div class="col-md-1">
          <input v-model="tmp_width" type="number" class="form-control wabident-xsmall" :id="slug + '_width'">
          <label :for="slug" :id="slug + '_width'" class="wabident-info">Ancho</label>
        </div>

        <div class="col-md-1">
          <input v-model="tmp_order" type="number" class="form-control wabident-xsmall" :id="slug + '_order'">
          <label :for="slug" :id="slug + '_order'" class="wabident-info">Orden</label>
        </div>

        <div class="col-md-1">
          <div class="form-check form-check-inline">
            <input class="form-check-input" :id="slug + '_important'" type="checkbox" :value="true"
              :checked="tmp_checked" @input="tmp_checked = $event.target.checked">
            <label class="form-check-label" :for="slug + '_important'">Import.</label>
          </div>
        </div>
      </template>

      <template v-else>
        <div class="col-md-6">
          <textarea v-if="decoration == 'textarea'" :id="slug + '_value'" class="form-control"
            v-model="tmp_value"></textarea>
          <input v-else v-model="tmp_value" type="text" class="form-control wabident-xsmall" :id="slug + '_value'">
          <label :for="slug" :id="slug + '_value'" class="wabident-info">Valor</label>
        </div>
      </template>

      <div class="col-md-2">
        <button @click="onAdd" class="btn-wabident-round">Añadir <i class="fas fa-plus"></i></button>
      </div>

    </div>
  </div>
</template>

<script>

export default {
  props: ['object', 'slug', 'decoration'],
  data() {
    return {
      tmp_key: '',
      tmp_value: null,
      // For fieldsets
      tmp_name: null,
      tmp_desc: null,
      tmp_order: null,
      tmp_checked: false,
      tmp_width: null,
      tmp_type: null,
    };
  },
  methods: {
    onDelete(key) {
      this.$emit('delete', key);
    },
    onAdd() {
      if (this.decoration == 'fieldset') {
        this.tmp_value = {
          name: this.tmp_name,
          desc: this.tmp_desc,
          type: this.tmp_type,
          width: this.tmp_width,
          order: this.tmp_order,
          important: this.tmp_checked,
        };
      }

      this.$emit('add', this.tmp_key, this.tmp_value);
      this.tmp_key = '';
      this.tmp_value = null;
      // For fieldsets
      this.tmp_name = null;
      this.tmp_desc = null;
      this.tmp_order = null;
      this.tmp_width = null;
      this.tmp_type = null;
    },
  }
}
</script>

<style lang="scss">
.wabident-object-field {
  &__item {
    border-bottom: 1px var(--theme-grey-bg) solid;
    padding-top: 10px;
    padding-bottom: 10px;
  }

}
</style>
